import { PlayIcon } from "lucide-react";
import { ReactNode, forwardRef } from "react";

interface EmptyPlaceholderProps {
  icon?: ReactNode;
  message?: string;
  className?: string;
  actions?: ReactNode;
}

const EmptyPlaceholder = forwardRef<HTMLDivElement, EmptyPlaceholderProps>(
  (
    {
      icon = <PlayIcon className="h-5 w-5 text-gray-400" />,
      message = "Run the prompt to see outputs here",
      className = "",
      actions,
    },
    ref,
  ) => (
    <div
      ref={ref}
      className={`flex h-24 w-full flex-col items-center justify-center gap-2 rounded-lg border border-gray-200 bg-gray-50 p-4 text-center ${className}`}
    >
      {icon}
      <span className="text-sm text-gray-500">{message}</span>
      {actions && <div className="mt-2 flex gap-2">{actions}</div>}
    </div>
  ),
);

EmptyPlaceholder.displayName = "EmptyPlaceholder";

export default EmptyPlaceholder;
